import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { SheetDb } from '../redux/sheetDbSlice';

const useSheetsDb = (bookId: string | null) : [string[], SheetDb[]] => {
  const sheetDb = useSelector((state: RootState) => state.sheetDb);
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const sheetTreeIds = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].bookId === bookId);
  const ids = sheetTreeIds.map(id => sheetTreeDb.sheetTrees[id].sheetId);
  const sheets = ids.map(id => sheetDb.sheets[id]);

  return [ids, sheets];
}

export default useSheetsDb;
